/** Server-advertised name for the user-elicitation (ask_user) tool. */
export const ASK_USER_TOOL_NAME = "ask_user";
